import CreditRepairOfferHolder from 'partial/OfferManager/holder/CreditRepairOfferHolder.js';
import PersonalLoanOfferHolder from 'partial/OfferManager/holder/PersonalLoanOfferHolder.js';
import CreditCardOfferHolder from 'partial/OfferManager/holder/CreditCardOfferHolder.js';
import AutoLoanOfferHolder from 'partial/OfferManager/holder/AutoLoanOfferHolder.js';
import './NativeAd.scss';
import NativeAdTemplate from 'components/Offers/StandardNativeAd/StandardNativeAd';

const NativeAdView = ({
  featuredAdOffer,
  customClass,
  eventHandler,
  offerPosition,
  modulePosition,
  isRenderedOnFactor,
}) => {
  const finalOfferPosition = offerPosition ? offerPosition : null;
  const pagePosition = 'Native Ad';

  switch (featuredAdOffer?.offerType) {
    case 'PERSONAL_LOAN':
      return (
        <PersonalLoanOfferHolder
          personalLoanTemplate={NativeAdTemplate}
          offerMetadata={featuredAdOffer}
          eventHandler={eventHandler}
          customClass={customClass}
          pagePosition={pagePosition}
          position={finalOfferPosition}
          modulePosition={modulePosition}
          isRenderedOnFactor={isRenderedOnFactor}
        />
      );
    case 'CREDIT_CARD':
      return (
        <CreditCardOfferHolder
          creditCardTemplate={NativeAdTemplate}
          offerMetadata={featuredAdOffer}
          eventHandler={eventHandler}
          customClass={customClass}
          pagePosition={pagePosition}
          position={finalOfferPosition}
          modulePosition={modulePosition}
          isRenderedOnFactor={isRenderedOnFactor}
        />
      );
    case 'CREDIT_REPAIR':
      return (
        <CreditRepairOfferHolder
          creditRepairTemplate={NativeAdTemplate}
          offerMetadata={featuredAdOffer}
          eventHandler={eventHandler}
          customClass={customClass}
          pagePosition={pagePosition}
          position={finalOfferPosition}
          modulePosition={modulePosition}
          isRenderedOnFactor={isRenderedOnFactor}
        />
      );
    case 'AUTO_LOAN':
      return (
        <AutoLoanOfferHolder
          autoLoanTemplate={NativeAdTemplate}
          offerMetadata={featuredAdOffer}
          eventHandler={eventHandler}
          pagePosition={pagePosition}
          position={finalOfferPosition}
          modulePosition={modulePosition}
          isRenderedOnFactor={isRenderedOnFactor}
        />
      );
    default:
      return <></>;
  }
};

export default NativeAdView;
